// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3Rfz-","right":"styles_right__rg2SF"};